/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacLibra = createReactComponent("zodiac-libra", "IconZodiacLibra", [
  ["path", { d: "M5 20l14 0", key: "svg-0" }],
  ["path", { d: "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5", key: "svg-1" }]
]);

export { IconZodiacLibra as default };
//# sourceMappingURL=IconZodiacLibra.js.map
